import React, { useState } from "react";
import { User, Users, CheckCircle } from "lucide-react";

const staffOptions = [
  { label: "Just me", icon: <User size={28} className="text-redlight" /> },
  { label: "2 - 7 staff", icon: <Users size={28} className="text-redlight" /> },
  {
    label: "8 - 20 staff",
    icon: <Users size={28} className="text-redlight" />,
  },
  {
    label: "Over 20 staff",
    icon: <Users size={28} className="text-redlight" />,
  },
];

const RegisterStep2 = ({ onNext }) => {
  const [selected, setSelected] = useState(null);

  const handleSelect = (label) => {
    setSelected(label);
    setTimeout(() => onNext?.(label), 300);
  };

  return (
    <div className="min-h-screen bg-dry flex flex-col items-center justify-start pt-16 px-5">
      <div className="text-center mb-8 bg-drylight w-screen py-16">
        <h2 className="text-3xl md:text-4xl font-medium mb-2 text-text px-3">
          And, how many bookable staff?
        </h2>
        <p className="text-textGray text-sm">
          Bookable staff are anyone in your business that has appointments with
          clients.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto">
        {staffOptions.map((item, idx) => {
          const isSelected = selected === item.label;

          return (
            <div
              key={idx}
              onClick={() => handleSelect(item.label)}
              className={`group flex flex-col items-center justify-center cursor-pointer border rounded-md p-6 transition text-center 
                hover:border-redlight hover:bg-redlightlight
                ${
                  isSelected
                    ? "border-redlight bg-redlightlight"
                    : "border-drylight bg-dry"
                }`}
            >
              <div className="mb-4">{item.icon}</div>

              <div
                className={`flex items-center gap-1 text-sm font-medium transition 
                  ${
                    isSelected ? "text-dry" : "text-text group-hover:text-dry"
                  }`}
              >
                {isSelected && <CheckCircle size={16} className="text-dry" />}
                {item.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegisterStep2;
